export const paginate = <T>(arr: T[], limit: number, offset: number): T[] => arr.slice(offset, offset + limit);
